import type { ManagementTranslations } from '../en-US/management.translations';

export const managementTranslations: ManagementTranslations = {
  title: 'BiteCritic Verwaltung',
  dashboard: 'Dashboard',
  users: 'Benutzerverwaltung',
  settings: 'Einstellungen',
  foods: {
    title: 'Essensverwaltung',
    createNew: 'Neues Essen hinzufügen',
    id: 'ID',
    name: 'Name',
    category: 'Kategorie',
    country: 'Land',
    status: 'Status',
    createdAt: 'Erstellt am',
    actions: 'Aktionen',
    noFoodsFound: 'Keine Speisen gefunden',
    searchPlaceholder: 'Speisen suchen...',
    allStatuses: 'Alle Status',
    allCategories: 'Alle Kategorien',
    sortNewest: 'Neueste zuerst',
    sortOldest: 'Älteste zuerst',
    sortNameAZ: 'Name A-Z',
    sortNameZA: 'Name Z-A',
    showing: 'Zeige {{from}} bis {{to}} von {{total}} Speisen',
    confirmDelete: 'Sind Sie sicher, dass Sie diese Speise löschen möchten?',
    approve: 'Genehmigen',
    reject: 'Ablehnen',
    createFood: 'Neue Speise erstellen',
    editFood: 'Speise bearbeiten',
    viewFood: 'Speisedetails anzeigen',
    namePlaceholder: 'Speisename eingeben',
    descriptionPlaceholder: 'Speisebeschreibung eingeben',
    selectCategory: 'Kategorie auswählen',
    selectCountry: 'Land auswählen',
    selectStatus: 'Status auswählen',
    imageUrl: 'Bild-URL',
    imageUrlPlaceholder: 'Bild-URL eingeben',
    imagePreview: 'Bildvorschau',
    rowsPerPage: '{{count}} pro Seite',
    translations: 'Übersetzungen',
    description: 'Beschreibung',
    formatJson: 'JSON formatieren',
    jsonPlaceholder: 'Speisedaten im JSON-Format eingeben',
    jsonInstructions: 'JSON-Format Anweisungen',
    jsonInstructionName: 'Name ist erforderlich und muss ein String sein',
    jsonInstructionCategory:
      'CategoryId ist erforderlich und muss eine Zahl sein',
    jsonInstructionCountry: 'CountryId ist optional und muss eine Zahl sein',
    jsonInstructionStatus: 'Status muss einer der folgenden sein',
    jsonInstructionTranslations:
      'Übersetzungen sollten ein Datensatz von Sprachcodes zu Übersetzungsobjekten sein',
    jsonUpdateError: 'Fehler beim Aktualisieren von {{field}}: {{error}}',
    hideFilters: 'Filter ausblenden',
    showFilters: 'Filter anzeigen',
    totalItems: 'Insgesamt {{count}} Einträge',
    aiPrompt: {
      title: 'Speisedaten mit KI generieren',
      description: 'KI zur Generierung von Speisedaten verwenden',
      inputLabel: 'Speisename',
      inputPlaceholder: 'Speisename eingeben',
      buttonText: 'Mit KI generieren',
      copyPrompt: 'Prompt kopieren',
      openInChatGPT: 'In ChatGPT öffnen',
      promptCopied: 'Prompt in die Zwischenablage kopiert!',
      instructions: 'Anweisungen:',
      step1: '1. Speisename eingeben',
      step2: '2. Auf "Mit KI generieren" klicken oder den Prompt kopieren',
      step3:
        '3. Den Prompt in ChatGPT einfügen oder auf "In ChatGPT öffnen" klicken',
      step4:
        '4. Die JSON-Antwort kopieren und zum Erstellen eines neuen Speiseeintrags verwenden',
    },
  },
  languages: {
    en: 'Englisch',
    nl: 'Niederländisch',
    tr: 'Türkisch',
    de: 'Deutsch',
    fr: 'Französisch',
    es: 'Spanisch',
    it: 'Italienisch',
    pt: 'Portugiesisch',
  },
};

export default managementTranslations;
